const MINUTE = 60_000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

const relative = new Intl.RelativeTimeFormat("fr", { numeric: "auto" });

/** « il y a 5 minutes », « hier »… puis la date au-delà d'une semaine. */
export function formatNotificationTime(createdAt: string, now: Date = new Date()): string {
  const created = new Date(createdAt);
  const elapsed = now.getTime() - created.getTime();
  if (elapsed < MINUTE) {
    return "à l'instant";
  }
  if (elapsed < HOUR) {
    return relative.format(-Math.floor(elapsed / MINUTE), "minute");
  }
  if (elapsed < DAY) {
    return relative.format(-Math.floor(elapsed / HOUR), "hour");
  }
  if (elapsed < 7 * DAY) {
    return relative.format(-Math.floor(elapsed / DAY), "day");
  }
  return created.toLocaleDateString("fr-FR", { day: "numeric", month: "short" });
}

/** Pastille de la cloche : rien sans notification nouvelle, « 9+ » au-delà de neuf. */
export function unreadBadgeLabel(count: number): string | null {
  if (count <= 0) {
    return null;
  }
  return count > 9 ? "9+" : String(count);
}
